module.exports = __webpack_public_path__ + "fonts/playfair-display-v22-latin-regular.4be70994.woff2";